import {
  AfterContentInit,
  Directive,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  input,
  Output,
} from '@angular/core';
import { EfInput } from '../shared/ef-input.interface';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[efInput]',
  standalone: true,
  host: {
    class:
      'text-body-01 text-gray-90 bg-white outline-none border-none rounded block w-full h-full appearance-none px-3',
    '[attr.id]': 'efInput()',
  },
  providers: [{ provide: EfInput, useExisting: forwardRef(() => EfInputDirective) }],
})
export class EfInputDirective extends EfInput implements AfterContentInit {
  public efInput = input<string>();

  // Zadanie na poprawke EFN-4828
  @Output()
  public onFocus = new EventEmitter<void>(); // eslint-disable-line @angular-eslint/no-output-on-prefix

  @Output()
  public onBlur = new EventEmitter<void>(); // eslint-disable-line @angular-eslint/no-output-on-prefix

  @Output()
  public onMouseEnter = new EventEmitter<void>(); // eslint-disable-line @angular-eslint/no-output-on-prefix

  @Output()
  public onMouseLeave = new EventEmitter<void>(); // eslint-disable-line @angular-eslint/no-output-on-prefix

  @HostListener('keydown.e')
  @HostListener('keydown.shift.e')
  public onKeydonwE(): boolean {
    return this.elementRef.nativeElement.type !== 'number';
  }

  constructor(
    public readonly elementRef: ElementRef,
    private readonly formControl: NgControl,
  ) {
    super();
  }

  @HostListener('focus')
  public focus(): void {
    this.onFocus.emit();
  }

  @HostListener('blur')
  public blur(): void {
    this.onBlur.emit();
  }

  @HostListener('mouseenter')
  public mouseenter(): void {
    this.onMouseEnter.emit();
  }

  @HostListener('mouseleave')
  public mouseleave(): void {
    this.onMouseLeave.emit();
  }

  public ngAfterContentInit(): void {
    if (!this.elementRef.nativeElement.name) {
      this.elementRef.nativeElement.name = this.formControl.name;
    }
  }
}
